import axios, { endpoints } from '../utils/axios';
import { setSession } from '../auth/context/utils';
import { paths } from '../routes/paths';

const interceptorCorrect = (response) => response;
// eslint-disable-next-line consistent-return
const interceptorError = async (error) => {
  if (error.response?.status === 402 || error.response?.status === 401) {
    sessionStorage.setItem('redirected', true);
    sessionStorage.setItem('redirectMessage', error.response?.data.error);
    sessionStorage.setItem('redirectSeverity', 'error');
    await setSession();
    /* eslint-disable no-restricted-globals */
    window.location.href = paths.auth.login;
  } else if (error.response?.status === 501) {
    //
  } else {
    return Promise.reject(error);
  }
};

class AnalysisService {
  static axiosInstance;

  static createAxios = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    console.log('Creating axios instance for financial service with user:', user);
    AnalysisService.axiosInstance = axios.create({
      withCredentials: true,
      headers: {
        ...axios.defaults.headers,
        User: user || '',
      },
    });

    AnalysisService.axiosInstance.interceptors.response.use(interceptorCorrect, interceptorError);

    return AnalysisService.axiosInstance;
  };

  static async getFinancialAnalysis(contextData) {
    const axiosInstance = this.createAxios();
    const endpoint = endpoints.api.analysis.getFinancialAnalysis;
    
    const response = await axiosInstance.post(endpoint, { contextData }); 
    
    return response.data;
  }

  static async getComparativeAnalysis(type, categories, values, reference) {
    const axiosInstance = this.createAxios();
    const endpoint = endpoints.api.analysis.getComparativeAnalysis;
    
    const response = await axiosInstance.post(endpoint, {
      type,   
      categories,
      values,
      reference
    });
    
    return response.data;
  }

  static async getConsumptionAnalysis(type, categories, values, reference) {
    const axiosInstance = this.createAxios();
    const endpoint = endpoints.api.analysis.getConsumptionAnalysis;
    
    const response = await axiosInstance.post(endpoint, {
      type,        // 'general' o 'sub'
      categories,
      values,
      reference
    });
    
    return response.data;
}
}

export default AnalysisService;
